<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Pencarian Konsultasi
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="4" class="mb-md-0 mb-2" v-if="!this.cekUPT">
          <label>Kanwil</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            v-model="searchForm.kanwilFilter"
            :options="kanwilOptions"
            :reduce="val => val.value"
            class="w-100"
            @input="val => changeUPT(val)"
          />
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2" v-if="!this.cekUPT">
          <label>UPT</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            v-model="searchForm.uptFilter"
            :options="uptOptions"
            class="w-100"
            :reduce="val => val.value"
          />
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <b-form-group label="Kategori" label-for="account-username">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="searchForm.kategori_jenis_tiket_id"
              :options="kategoriJenisTiketOptions"
              :reduce="val => val.value"
              class="w-100"
              @input="val => changeKategori(val)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <b-form-group label="Jenis" label-for="account-username">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="searchForm.jenis_tiket_id"
              :options="jenisTiketOptions"
              :reduce="val => val.value"
              class="w-100"
            />
          </b-form-group>
        </b-col>
        <!-- <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <b-form-group
            label="Keterangan"
            label-for="account-username"
          >
            <b-form-input
              v-model="searchForm.keterangan"
              placeholder="Keterangan"
              name="username"
              class="form-control"
            />
          </b-form-group>
        </b-col> -->
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <b-form-group>
            <label for="status-tiket-select">
              Status<span :style="{ color: 'red' }"> *</span>
            </label>
            <v-select
              id="status-tiket-select"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="searchForm.status_tiket_id"
              :options="statusTiketOptions"
              :reduce="val => val.value"
              class="w-100"
              multiple
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>Periode Tanggal Pengajuan</label>
          <flat-pickr
            v-model="searchForm.periodeFilter"
            :config="{ mode: 'range' }"
            class="form-control flat-picker bg-transparent border-1 shadow-none"
            placeholder="YYYY-MM-DD to YYYY-MM-DD"
          />
        </b-col>
        <b-col cols="12" :style="{ marginTop: '1%' }">
          <b-button variant="primary" @click="cariData" class="mr-1">
            <span class="text-nowrap">Cari</span>
          </b-button>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col cols="12" v-if="!this.cekUPT">
          <span :style="{ color: 'black', fontWeight: 'bold' }"
            >**Catatan : Silahkan Status Proses nya Terlebih Dahulu Sebelum Melakukan Filter Lacak
            Konsultasi</span
          >
        </b-col>
        <b-col cols="12" v-if="this.cekUPT">
          <span :style="{ color: 'black', fontWeight: 'bold' }"
            >**Catatan : Silahkan Status Proses nya Terlebih Dahulu Sebelum Melakukan Filter Lacak
            Konsultasi</span
          >
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormGroup,
    // BFormInput,
    BButton,
    flatPickr,
  },
  data() {
    return {
      searchForm: {
        keterangan: '',
        kategori_jenis_tiket_id: null,
        jenis_tiket_id: null,
        status_tiket_id: null,
        kanwilFilter: null,
        uptFilter: null,
        periodeFilter: null,
      },
      userData: JSON.parse(localStorage.getItem('userData')),
      cekUPT: false,
    }
  },
  props: {
    // kanwilFilter: {
    //   type: [Number, null],
    //   default: null,
    // },
    kategoriJenisTiketOptions: {
      type: Array,
      required: true,
    },
    jenisTiketOptions: {
      type: Array,
      required: true,
    },
    statusTiketOptions: {
      type: Array,
      required: true,
    },
    kanwilOptions: {
      type: Array,
      required: true,
    },
    uptOptions: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    // console.log(this.userData.roles.includes('users'))
    if (this.userData.roles.includes('users')) {
      this.cekUPT = true
    }
    this.$emit('emitFilter', this.searchForm)
    // const d = new Date()
    // const tanggalAwal = d.setMonth(d.getMonth() - 6)
    // this.searchForm.tanggal_mulai = tanggalAwal
    // const dn = new Date()
    // const tanggalAkhir = dn.setMonth(dn.getMonth() + 3)
    // this.searchForm.tanggal_akhir = tanggalAkhir
  },
  methods: {
    cariData() {
      // console.log(this.searchForm)
      this.$emit('emitFilter', this.searchForm)
      this.$emit('update:kanwilFilter', this.searchForm.kanwilFilter)
      this.$emit('update:kategoriFilter', this.searchForm.kategori_jenis_tiket_id)
      this.$emit('update:jenisFilter', this.searchForm.jenis_tiket_id)
      this.$emit('update:statusFilter', this.searchForm.status_tiket_id)
      this.$emit('update:uptFilter', this.searchForm.uptFilter)
      this.$emit('update:periodeFilter', this.searchForm.periodeFilter)
    },
    changeUPT(value) {
      // console.log(value)
      this.$emit('emitReceiverUPT', value)
    },
    changeKategori(value) {
      // console.log(value)
      this.$emit('emitReceiverKategori', value)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
